import { combineReducers } from "redux"

import members from "./community-participants/community-members-paging-reducer"
import managers from "./community-participants/community-managers-paging-reducer"
import followers from "./community-participants/community-followers-paging-reducer"
import invited from "./community-participants/community-invited-paging-reducer"
import awaitingApproval from "./community-participants/community-awaiting-approval-paging-reducer"

export default combineReducers({
    members,
    managers,
    followers,
    invited,
    awaitingApproval
})
